import React, { useState } from 'react';
import RichTextEditor from './crm/RichTextEditor';

/**
 * Standalone test harness for the RichTextEditor. Mounted at /dev/editor-test.
 * Lets QA verify upload / drag-drop / paste image handling without needing to
 * log into the CRM (useful when the CRM DB is unreachable in preview).
 */
export default function EditorTest() {
  const [html, setHtml] = useState('<p>Type here, drag/drop an image, or paste a screenshot with <strong>Ctrl+V</strong>.</p>');
  const imgCount = (html.match(/<img /g) || []).length;

  return (
    <div className="min-h-screen bg-gray-50 p-6" data-testid="editor-test-page">
      <div className="max-w-3xl mx-auto space-y-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 mb-1">Rich Text Editor · Image Upload Test</h1>
          <p className="text-sm text-gray-600">Three ways to add an image: <strong>upload button</strong>, <strong>drag &amp; drop</strong>, <strong>paste (Ctrl+V)</strong>. Plus URL insert for hosted images.</p>
        </div>

        <div className="bg-white rounded-lg border border-slate-200 p-1">
          <RichTextEditor
            value={html}
            onChange={setHtml}
            minHeight={400}
            testid="editor-test"
          />
        </div>

        <div className="grid grid-cols-2 gap-3 text-sm">
          <div className="bg-white p-3 rounded border border-slate-200">
            <div className="font-semibold text-slate-900 mb-1">Live stats</div>
            <div data-testid="editor-test-img-count">Images in document: <span className="font-mono">{imgCount}</span></div>
            <div>HTML length: <span className="font-mono">{html.length.toLocaleString()}</span></div>
          </div>
          <div className="bg-white p-3 rounded border border-slate-200">
            <div className="font-semibold text-slate-900 mb-1">Try:</div>
            <ul className="text-gray-600 space-y-0.5 list-disc list-inside">
              <li>Click the <strong>image (+)</strong> toolbar button</li>
              <li>Drag any image file onto the editor</li>
              <li>Copy an image, then paste (Ctrl+V) here</li>
            </ul>
          </div>
        </div>

        <details className="bg-white p-3 rounded border border-slate-200 text-xs">
          <summary className="cursor-pointer text-slate-700 font-semibold">HTML output (click to expand)</summary>
          <pre className="mt-2 overflow-auto bg-slate-50 p-3 rounded text-slate-700 max-h-64" data-testid="editor-test-html">{html}</pre>
        </details>
      </div>
    </div>
  );
}
